import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompetitivePriceEntity } from './competitive-price.entity';
import { FileEntity } from './file.entity';

@Index('_fk__file__id', ['fkFileId'], {})
@Index('_fk_competitive_price__id', ['fkCompetitivePriceId'], {})
@Entity('competitive_price__file')
export class CompetitivePriceFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', nullable: true, unsigned: true })
	public fkFileId!: number | null;

	@Column('int', {
		name: '_fk_competitive_price__id',
		nullable: true,
		unsigned: true,
	})
	public fkCompetitivePriceId!: number | null;

	@ManyToOne(() => FileEntity, (file) => file.competitivePriceFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;

	@ManyToOne(
		() => CompetitivePriceEntity,
		(competitivePrice) => competitivePrice.competitivePriceFiles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_competitive_price__id', referencedColumnName: 'id' },
	])
	public fkCompetitivePrice!: CompetitivePriceEntity;
}
